import { useId } from 'react'

import { SwitchButton } from '@avantstay/backoffice-core'

interface NotesFilterProps {
  value: boolean
  onChange: (showNotes: boolean) => void
}

export const NotesFilter = ({ value, onChange }: NotesFilterProps) => {
  const id = useId()

  return (
    <SwitchButton
      id={id}
      titleLeft="Notes"
      checked={value}
      onChange={event => onChange(event.target.checked)}
    />
  )
}
